import {defaultTo, get, pipe, stubArray} from '@yandex-delivery/utils'

/**
 * У каждой страны есть свой определенный список требований к оформлению
 * и нам нужно учитывать это при проектировании интерфейса
 */
export function useDefaultTariffRequirements() {
  return pipe({}, get('cargo_create_default_true_requirements'), defaultTo(stubArray()))
}
